import React, {Component} from 'react';

import swal from 'sweetalert2';
import axios from "axios/index";

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import {ajaxHandler} from "../../../../utils/errors";

export default class IslandDelete extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ajaxInProgress: false
        };
    }

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let data = {
            active: false,
            terminal: this.props.item.terminal.id,
            code: this.props.item.code,
            name: this.props.item.name
        };

        const DELETE_ISLAND = `${urls.API_ROOT}/api/v1/loadingislands/id/${this.props.item.id}/`;
        axios.put(`${DELETE_ISLAND}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(ajaxHandler);
    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false});

        swal({
            title: `Isla de Descaga desactivada`,
            html: 'La isla ha sido desactivado correctamente',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
        });

        this.props.closeAction();
        this.props.refreshAction();
    };

    render() {
        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>Eliminar Isla de Descarga</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <p>
                            Usted esta por desactivar la isla <b>{this.props.item.name}</b>.
                            Esta acción no puede deshacerse. ¿Desea continuar?
                        </p>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={`btn btn-shell-empty z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={`btn btn-shell z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this._submitForm}
                        >Continuar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/IslandDelete.js